import { urlFormat } from '@datapad/utilities';
import { baseImageUrl } from './Constants.js';
import { getSizedFactionUrls } from './FactionImageUtilities.js';
import { getMaxImageDimensionInPixels, loadAndRenderImage } from './ImageUtilities.js';
const missingContactImageUrl = `${baseImageUrl}/contacts/missing-contact.png`;
export var CharacterImageSize;
(function (CharacterImageSize) {
    CharacterImageSize["Full"] = "full";
    CharacterImageSize["Profile"] = "profile";
    CharacterImageSize["Thumbnail"] = "thumbnail";
})(CharacterImageSize || (CharacterImageSize = {}));
export var CharacterImageVariant;
(function (CharacterImageVariant) {
    CharacterImageVariant["Full"] = "full";
    CharacterImageVariant["Profile"] = "profile";
})(CharacterImageVariant || (CharacterImageVariant = {}));
export function renderFactionEmblemForFirstAffiliation(character, options) {
    const cleanedNames = character.affiliations.map((factionName) => urlFormat(factionName));
    const factionImageUrls = [];
    cleanedNames.forEach((cleanedName) => {
        const urls = getSizedFactionUrls(`${baseImageUrl}/factions/${cleanedName}`, options);
        factionImageUrls.push(...urls);
    });
    const key = cleanedNames.reduce((aggregate, current) => `${aggregate}-${current}`);
    return loadAndRenderImage(factionImageUrls, options, `${key}-image`);
}
export function renderCharacterImage(character, options) {
    const cleanedName = urlFormat(character.name);
    const contactImageUrls = getSizedCharacterUrl(`${baseImageUrl}/contacts/${cleanedName}`, options);
    const urls = [contactImageUrls, missingContactImageUrl];
    return loadAndRenderImage(urls, options, `${cleanedName}-image`);
}
export function renderCharacterPlaceholderImage(options) {
    return loadAndRenderImage([missingContactImageUrl], options, 'missing-contact-image');
}
export var CampaignImageSize;
(function (CampaignImageSize) {
    CampaignImageSize["Small"] = "small";
    CampaignImageSize["Large"] = "large";
})(CampaignImageSize || (CampaignImageSize = {}));
export function renderCampaignImage(campaign, options) {
    if (campaign.imageResourceName === undefined) {
        return undefined;
    }
    const cleanedName = urlFormat(campaign.imageResourceName);
    const campaignImageUrls = getSizedCampaignUrls(`${baseImageUrl}/campaigns/${cleanedName}`, options);
    return loadAndRenderImage(campaignImageUrls, options, `${cleanedName}-campaign-image`);
}
function getCampaignImageSizes(options) {
    const maxImageDimensionInPixels = getMaxImageDimensionInPixels(options.maxHeightInPixels, options.maxWidthInPixels);
    if (maxImageDimensionInPixels === undefined || maxImageDimensionInPixels > 100) {
        return [CampaignImageSize.Large, CampaignImageSize.Small];
    }
    return [CampaignImageSize.Small, CampaignImageSize.Large];
}
function getSizedCampaignUrls(urlBase, options) {
    const recommendedSizes = getCampaignImageSizes(options);
    return recommendedSizes.map((size) => `${urlBase}-${size}.png`);
}
function getCharacterImageSize(options) {
    if (options.variant === CharacterImageVariant.Full) {
        return CharacterImageSize.Full;
    }
    const maxImageDimensionInPixels = getMaxImageDimensionInPixels(options.maxHeightInPixels, options.maxWidthInPixels);
    return maxImageDimensionInPixels === undefined || maxImageDimensionInPixels > 150
        ? CharacterImageSize.Profile
        : CharacterImageSize.Thumbnail;
}
function getSizedCharacterUrl(urlBase, options) {
    const size = getCharacterImageSize(options);
    return `${urlBase}-${size}.png`;
}
//# sourceMappingURL=CharacterImageUtilities.js.map